import ProductTypesIndex from '@pages/product-types/ProductTypeIndex'
import { beforeRouteEnterAction } from '@router/router.utils'

export default [
  {
    path: '/product-types',
    name: 'product-types',
    component: ProductTypesIndex,
    meta: {
      requiresAuth: true,
      actions: ['productTypes/getAll'],
      pageTitle: 'Product Types',
      pathToLocalization: 'productTypes.title'
    },
    beforeEnter: beforeRouteEnterAction
  }
]
